import { Search } from 'lucide-react';
import { memo, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  setSearchQuery,
  clearSearchQuery,
} from '../../../features/product/productSearchSlice';
import { useLocation, useNavigate } from 'react-router-dom';

const SearchQuery = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: { search: '' },
  });

  useEffect(() => {
    // Always clear on route change
    reset({ search: '' });
  }, [location.key, reset]);

  const onSubmit = ({ search }) => {
    const searchTerm = search.trim().toLowerCase();
    if (!searchTerm) return;
    dispatch(setSearchQuery(searchTerm));
    navigate(`/search-results?q=${searchTerm}`);
    reset({ search: '' });
  };

  return (
    <div className="flex w-full lg:w-2/5">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full font-duplet">
        <label htmlFor="search" className="sr-only">
          Search for products
        </label>
        <div className="relative flex items-center">
          <input
            type="text"
            id="search"
            aria-label="Search for products"
            {...register('search')}
            placeholder="Search for anything"
            className="rounded-full pl-6 py-2  border border-black  text-sm w-full 
                       focus:ring-2 focus:ring-[#FFDE11] focus:border-transparent 
                       transition-all hover:border-[#FFDE11] motion-safe:duration-200 
                       bg-[#ECEDF1] font-duplet placeholder-[#737376]"
          />
          <button
            type="submit"
            id="search-button"
            aria-label="Submit search"
            className="absolute flex h-full rounded-r-full border border-black right-0 items-center py-2 px-4 
                       bg-[var(--yellow-primary)] rounded-[10px]
                       hover:bg-[#FFD700] active:bg-[#FFC107] 
                       focus:ring-2 focus:ring-[var(--yellow-primary)]  
                       transition-all motion-safe:duration-200 hover:scale-105 active:scale-95"
          >
            <Search size={16} aria-hidden="true" />
          </button>
        </div>
      </form>
    </div>
  );
};

export default memo(SearchQuery);
